<template>
  <div class="protospellings">
    <b-container fluid="xxl">
      <b-row class="text-center">
        <b-col>
          <input
            class="px-2 py-1 w-100"
            id="search"
            type="text"
            size="sm"
            placeholder="Search protospellings"
            @keyup="getSearchResults()"
            autocomplete="off"
            v-model="query"
          />
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <ul v-if="protospellings.length" class="results-ul">
            <li v-for="protospelling in protospellings" :key="protospelling.id">
              <a href="#" @click="selectProtospelling($event, protospelling)">{{ protospelling.spelling }}</a>
            </li>
          </ul>
          <span v-else class="opacity-60">
            <span v-if="query">No results</span>
            <span v-else>Start searching</span>
          </span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'ProtospellingAutocomplete',
    props: ['exclude'],
    data() {
      this.$store.state.protospelling.protospellings = []
      return {
        query: '',
        timer: null
      }
    },
    mounted() {
      this.$store.state.protospelling.protospellings = []
    },
    computed: {
      ...mapState({
        protospellings: state => state.protospelling.protospellings
      }),
      clearQuery(){
        return this.query.replace(/\*/gi, '')
      }
    },
    methods: {
      selectProtospelling(event, protospelling){
        event.preventDefault()
        this.$emit('select', protospelling)
        this.$store.state.protospelling.protospellings = []
        this.query = ''
      },
      getSearchResults(){
        clearTimeout(this.timer)
        // let that = this
        this.timer = setTimeout(() => {
          this.$store.dispatch('searchProtospellings', {
            query: this.query.toLowerCase(),
            exclude: (this.exclude ? this.exclude : [])
          })
        }, 400)
      }
    }
  }
</script>
